<!-- =========================================================================================
	File Name: FullPage.vue
	Description: Full page layout
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Version: 1.1
	Author: Pixinvent
	Author URL: hhttp://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div class="layout--full-page">
		<router-view></router-view>
	</div>
</template>
<script>

export default {
	mounted() {
		if(this.$store.state.authToken){
			
			if (this.$store.state.uInfo) {
				if(this.$store.state.uInfo.role === 'SA'){
                   this.$router.push({ name: "adminDashboard" });
				}
				if(this.$store.state.uInfo.role === 'CA' || this.$store.state.uInfo.role === 'HR'){
				   this.$router.push({ name: "organizationDashboard" });
				}
				if(this.$store.state.uInfo.role === 'U'){
				   this.$router.push({ name: "userDashboard" });
				}
			}

		     
		}
	}
}
</script>
